import Grid from '@mui/material/Grid';
import { BetaChip } from '@buoyhealth/common.buoy-chip';
import { Paragraph } from 'src/interviews/components/Layout/Embedded';
import RelatedQuestion from './RelatedQuestion';
import LoadingSkeleton from 'src/interviews/components/LoadingSkeleton';

import type { RelatedQuestionType } from '../../hooks/useRelatedQuestions';

const MAX_COUNT = 4;

type Props = {
  isLoading: boolean;
  questions: RelatedQuestionType[];
};

const RelatedQuestions = ({ isLoading, questions }: Props) => {
  if (!questions?.length && !isLoading) {
    return null;
  }

  return (
    <Grid item className="bp-w-full">
      <div className="bp-flex bp-flex-col bp-gap-4">
        <div className="bp-flex bp-items-center bp-justify-between bp-gap-2">
          <Paragraph className="bp-text-lg !bp-font-bold">Related questions</Paragraph>
          <BetaChip className="bp-text-[8px] bp-uppercase" label="⚡️ Powered by AI" />
        </div>
        {isLoading ? (
          Array(MAX_COUNT)
            .fill(null)
            .map((_, index) => <LoadingSkeleton key={`rq-loading-skeleton-${index}`} />)
        ) : (
          <div className="bp-flex bp-flex-col bp-gap-2">
            {questions.map((question, i) => (
              <RelatedQuestion key={question.question} question={question} index={i} />
            ))}
          </div>
        )}
      </div>
    </Grid>
  );
};

export default RelatedQuestions;
